import React from 'react';

import Loading from 'components/Loading';

interface Props<T>
{
  isLoading: boolean,
  suggestionsVisible: boolean,
  noSuggestionsView: React.ReactNode,
  suggestions: T[],
  maxSuggestions: number,
  onSuggestionSelect: (x: T) => void,
  suggestionViewTemplate: (x: T) => React.ReactNode,
  suggestionKeySelector: (x: T) => string,
  children?: React.ReactNode,
}

export const SuggestionsSelector = <T,>({isLoading,
                                         suggestionsVisible,
                                         noSuggestionsView,
                                         suggestions,
                                         maxSuggestions,
                                         suggestionKeySelector,
                                         suggestionViewTemplate,
                                         onSuggestionSelect,
                                         children} : Props<T>) =>
{
  if (maxSuggestions < 1)
  {
    maxSuggestions = 1;
  }
  let suggestionsContent = <></>;
  if (isLoading)
  {
    suggestionsContent = <Loading />;
  }
  else
  {
    if (suggestions && suggestions.length > 0)
    {
      suggestionsContent = <>{suggestions.slice(0, maxSuggestions).map(x=> <div className="suggestion" onClick={() => onSuggestionSelect(x)} key={suggestionKeySelector(x)}>{suggestionViewTemplate(x)}</div>)}</>;
    }
    else
    {
      suggestionsContent = <>{noSuggestionsView}</>;
    }
  }
  return (
    <div className="with-suggestions">
      <div className={['suggestions', suggestionsVisible ? 'visible' : ''].join(' ')}>{suggestionsContent}</div>
      {children}
    </div>
  );
}